import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { getters } from "EventLight/Sessions/PortalSessionModal/model";
import { Divider } from "EventLight/Common/FieldLayout";
import { Div } from "components/Base";
import css from "./styles.scss";

const decorate = connect(
  state => ({
    data: getters.data(state)
  }),
  {}
);

const labelTitleStyle = {
  color: "#343434",
  fontSize: "16px",
  fontWeight: 600,
  wordWrap: "break-word"
};

const textStyle = {
  color: "#494949",
  fontSize: "16px",
  fontWeight: 400,
  wordWrap: "break-word"
};

const LabelText = ({ label, text = "-" }) => {
  return (
    <Div style={{ gap: "8px" }} display="column.flex-star.flex-start">
      <div style={labelTitleStyle}>{label}</div>
      {label !== "Description" && (
        <div style={textStyle}>
          {R.isEmpty(text) || R.isNil(text) ? "-" : text}
        </div>
      )}
      {label === "Description" && (
        <div
          className={css.descriptionStyle}
          dangerouslySetInnerHTML={{
            __html: R.isEmpty(text) || R.isNil(text) ? "-" : text
          }}
        ></div>
      )}
    </Div>
  );
};

const PropLabel = ({ prop = "", value = "-" }) => {
  return (
    <Div style={{ gap: "8px" }} display="row.flex-star.flex-start">
      <div style={{ ...labelTitleStyle, width: "112px" }}>{prop}:</div>
      <div style={textStyle}>
        {R.isEmpty(value) || R.isNil(value) ? "-" : value}
      </div>
    </Div>
  );
};

const DetailsContent = ({ data }) => {
  if (R.isEmpty(data) || R.isNil(data)) {
    return null;
  }

  const {
    speakers = "-",
    description = "-",
    startsAt,
    endsAt,
    level = "-",
    format = "-",
    track = "-",
    language = "-",
    ceu = "-",
    isSubsession = false
  } = data || {};

  const startsAtFormatted =
    startsAt && startsAt.formatted ? startsAt.formatted : "-";
  const endsAtAtFormatted = endsAt && endsAt.formatted ? endsAt.formatted : "-";

  return (
    <Div
      bg="neutral0"
      style={{ overflowY: "auto", padding: "0 8px 8px 8px", height: 650 }}
    >
      <Div
        bg="white"
        bra={3}
        display="column"
        mb={4}
        style={{
          border: "1px solid #eee",
          padding: "20px",
          gap: "12px"
        }}
      >
        <LabelText
          label="Speakers"
          text={speakers && speakers.length ? speakers : "-"}
        />
        <Divider bg={"#E7E6EA"} my={0} />
        <LabelText
          label="Description"
          text={description && description.length ? description : "-"}
        />
        <Divider bg={"#E7E6EA"} my={0} />

        <PropLabel
          prop="Starts At"
          value={
            startsAtFormatted && startsAtFormatted.length
              ? startsAtFormatted
              : "-"
          }
        />
        <PropLabel
          prop="Ends At"
          value={
            endsAtAtFormatted && endsAtAtFormatted.length
              ? endsAtAtFormatted
              : "-"
          }
        />

        {!isSubsession && language && language.length ? (
          <PropLabel
            prop="Language"
            value={language && language.length ? language : "-"}
          />
        ) : null}
        {!isSubsession && ceu && ceu.length ? (
          <PropLabel prop="CEU Credits" value={ceu && ceu.length ? ceu : "-"} />
        ) : null}
        {!isSubsession && <Divider bg="#E7E6EA" my={0} />}
        {format && format.length ? (
          <PropLabel
            prop="Format"
            value={format && format.length ? format : "-"}
          />
        ) : null}
        {!isSubsession && (
          <PropLabel prop="Track" value={track && track.length ? track : "-"} />
        )}
        {!isSubsession && (
          <PropLabel prop="Level" value={level && level.length ? level : "-"} />
        )}
      </Div>
    </Div>
  );
};

export default decorate(DetailsContent);
